import { useAPI } from "kw/api/useAPI";
import { $ } from "kw/api";
import { useState } from "react";

export const useReports = () => {
  const [reports, setReports] = useState<TReports>();
  const { query, loading } = useAPI();
  const fetchReports = (search = "", filterBy = "ALL", page: number) => {
    query(
      reportsQuery,
      (response: { admin: { reports: TReports } }) => {
        setReports(response.admin.reports);
      },
      {
        search,
        filterBy,
        page,
      }
    );
  };

  const searchReports = (search = "", filterBy = "ALL", page = 1) => {
    query(
      reportsQuery,
      (response: { admin: { reports: TReports } }) => {
        setReports(response.admin.reports);
      },
      {
        search: search,
        filterBy: filterBy,
        page: page,
      }
    );
  };

  return {
    reports,
    loading,
    fetchReports,
    searchReports,
  };
};

const reportsQuery = {
  admin: {
    reports: [
      {
        search: $("search", "String!"),
        filterBy: $("filterBy", "String!"),
        page: $("page", "Int!"),
      },
      {
        totalItemCount: true,
        page: true,
        pageCount: true,
        pageSize: true,
        hasNext: true,
        hasPrev: true,
        items: {
          id: true,
          name: true,
          generatedDate: true,
          startDatetime: true,
          endDatetime: true,
          reportType: true,
          url: true,
          taskStatus: true,
        },
        reportTypes: true,
      },
    ],
  },
};
